import styled from 'styled-components';
import { Tooltip } from 'antd';

const customTooltip = styled(Tooltip)`
  .contribution .ant-tooltip {
    top: 1853px !important;
  }
`;

export const TooltipContainer = styled(customTooltip)`
  position: relative;
  left: 0;
  display: inline-block;
`;
